import {SITE_NAME} from '../config/config.js'
/*
use example
in Vue component:
export default {
    title: 'dsfsdfds',
    asyncData() {
    ...async data required
    }
}
in Vue component:
export default {
    title: function() {
       return this.serverData.title
    },
    asyncData() {
    ...async data required
    }
}
disable get title:
title: false
in routes:
...mponent: Garbages, name: 'garbages', meta: {title: 'Организация/ИП'}
 */
function getTitle (vm) {
  let {title, asyncData} = vm.$options
  // ignore components without asyncData
  // console.log(title, asyncData)
  if (asyncData === undefined) {
    return null
  }
  // get title
  if (title) {
    title = typeof title === 'function'
      ? title.call(vm)
      : title
  } else if (title !== false && vm.$route && vm.$route.meta && vm.$route.meta.title) {
    title = vm.$route.meta.title
  }
  return title ? `${vm.$translate(title)} - ${vm.$translate(SITE_NAME)}` : null
}

const serverTitleMixin = {
  created () {
    const title = getTitle(this)
    if (title) {
      this.$root.$options.ssrContext.title = `${title}`
    }
  }
}
const clientTitleMixin = {
  // mounted () {
  //   const title = getTitle(this)
  //   if (title) {
  //     document.title = `${title}`
  //     this.$store.commit('setNavbarTitle',title,this.$options.name)
  //   }
  // },
  created () {
    const title = getTitle(this)
    if (title !== null) {
      document.title = `${title}`
    }
  },
  watch: {
    '$route' () {
      const title = getTitle(this)
      if (title !== null) {
        document.title = `${title}`
      }
    }
  }
}
export default process.env.VUE_ENV === 'server'
  ? serverTitleMixin
  : clientTitleMixin
